import { render, staticRenderFns } from "./target_drug.vue?vue&type=template&id=048b21c9&"
import script from "./target_drug.vue?vue&type=script&lang=js&"
export * from "./target_drug.vue?vue&type=script&lang=js&"
import style0 from "./target_drug.vue?vue&type=style&index=0&id=048b21c9&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports